// Default environment
// This file is used as fallback when no client is specified
// For client-specific builds, use environment.clientX.ts files
export const environment = {
  production: false,
  client: process.env.REACT_APP_CLIENT || 'toender',
  configUrl: process.env.REACT_APP_CONFIG_URL || '/assets/config/toender.json'
};

